import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { keizerConfig } from "./data";

export default function KeizerPage() {
  return <OregonCityPageTemplate config={keizerConfig} />;
}